import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createAcceptance,
  createBaggage,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  MockAcceptance,
  MockJourneyElementCommon,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  twoAdtJourneyTravelers,
} from '../../mock';
import {
  acceptedMultiLegMultiPaxJourney,
  addedBaggageTemplate,
  defaultCheckInBaggagePoliciesFor2Adt,
  firstFreeSeatOnMultiLegJourney,
  multiLegBoardingPassResultForSameFreeSeats,
  multiLegMultiPaxJourneys,
  multiLegSeatmap,
  noItemToPayError,
  secondFreeSeatOnMultiLegJourney,
} from '../../mock/data';

const checkedInJourneyElementFirstSeatForFirstPax: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        checkInStatus: 'accepted',
        traveler: twoAdtJourneyTravelers[0],
        travelerId: twoAdtJourneyTravelers[0].id,
        legs: [
          {
            boardPointIataCode: 'NCE',
            offPointIataCode: 'CDG',
            scheduledArrivalDateTime: todayPlusNdays('9:20', 2),
            scheduledDepartureDateTime: todayPlusNdays('9:00', 2),
            seat: firstFreeSeatOnMultiLegJourney[0]
          },
          {
            boardPointIataCode: 'CDG',
            offPointIataCode: 'LHR',
            scheduledArrivalDateTime: todayPlusNdays('10:00', 2),
            scheduledDepartureDateTime: todayPlusNdays('9:30', 2),
            seat: firstFreeSeatOnMultiLegJourney[0]
          }
        ]
      }
    })
  }
});

const checkedInJourneyElementSecondSeatForSecondPax: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        checkInStatus: 'accepted',
        traveler: twoAdtJourneyTravelers[1],
        travelerId: twoAdtJourneyTravelers[1].id,
        legs: [
          {
            boardPointIataCode: 'NCE',
            offPointIataCode: 'CDG',
            scheduledArrivalDateTime: todayPlusNdays('9:20', 2),
            scheduledDepartureDateTime: todayPlusNdays('9:00', 2),
            seat: secondFreeSeatOnMultiLegJourney[0]
          },
          {
            boardPointIataCode: 'CDG',
            offPointIataCode: 'LHR',
            scheduledArrivalDateTime: todayPlusNdays('10:00', 2),
            scheduledDepartureDateTime: todayPlusNdays('9:30', 2),
            seat: secondFreeSeatOnMultiLegJourney[0]
          }
        ]
      }
    })
  }
});

const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: [checkedInJourneyElementFirstSeatForFirstPax, checkedInJourneyElementSecondSeatForSecondPax],
    isAccepted: true
  }
});

/**
 * OW Multileg 1Journey
 * 2ADT
 * free seats
 */

export const owMultileg2AdtSeatDetailsInOverviewRetrieve: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(multiLegBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForSameFreeSeats, 201),
    createMockDataWithResponse(multiLegBoardingPassResultForSameFreeSeats, 201)
  ],
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 1
    })
  ])],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePoliciesFor2Adt]).items)],
  getJourneyUnpaidItems: [
    createMockData(noItemToPayError)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstFreeSeatOnMultiLegJourney[0], 201)
  ],
  updateJourneySeats: [
    createMockData(firstFreeSeatOnMultiLegJourney)
  ],
  updateJourneyElement: [
    createMockData(firstFreeSeatOnMultiLegJourney)
  ],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(acceptance, 201)
  ],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(multiLegMultiPaxJourneys, 201),
    createMockDataWithResponse([acceptedMultiLegMultiPaxJourney], 201)
  ],
  retrieveJourney: [
    createMockData({
      ...acceptedMultiLegMultiPaxJourney,
      journeyElements: [checkedInJourneyElementFirstSeatForFirstPax, checkedInJourneyElementSecondSeatForSecondPax]
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(multiLegSeatmap)]
};
